import{groupSchema}from'soapbox/schemas';import{filteredArray}from'soapbox/schemas/utils';import{QueryKeys}from'../../query-keys';import{importEntities}from'../index';/**
 * Import groups to the global cache from a list of groups.
 *
 * @param groups - array of Groups
 */function importGroups(groups){var parsedResult=filteredArray(groupSchema).safeParse(groups);if(parsedResult.success){importEntities(QueryKeys.groups.global,parsedResult.data);}}export{importGroups};